import React from "react";
import { Card, CardContent, Grid } from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonDashboardReport = (props: any) => {
    return (
        <>
            <Grid container spacing={3} style={{ height: "50%", marginLeft: 0 }}>
                {Array.from({length: 9}, (_, index) => index + 1).map((value) => (
                    <Grid item xs={4} key={"griditemskeleton" + value}>
                        <Card variant="outlined" className="basic_card">
                            <CardContent>
                                <h2>
                                    <Skeleton count={5} height={16} duration={0.5}/>
                                </h2>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default SkeletonDashboardReport;
